import { useState, ChangeEvent } from 'react'
import { InputAdornment, IconButton, TextField, TextFieldProps, Tooltip } from '@mui/material'
import { Check, Close, Edit } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

export interface ClampRatioFieldProps extends Omit<TextFieldProps, 'value'> {
  value?: number | null
  allowEmpty?: boolean
  onValueChange: (value: number | null) => void
}

export default function ClampRatioField({
  value,
  allowEmpty = false,
  disabled = false,
  onValueChange,
  onChange,
  ...props
}: ClampRatioFieldProps) {
  const { t } = useTranslation('manufacturing')

  const [isEditing, setEditing] = useState<boolean>(false)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)

    if (allowEmpty && (event.target.value === '' || event.target.value === null)) {
      onValueChange(null)
    } else {
      const newValue = parseInt(event.target.value, 10)
      if (!isNaN(newValue)) {
        onValueChange(newValue)
      }
    }
  }

  return (
    <TextField
      type="number"
      label={t('clampRatio')}
      value={value !== undefined && value !== null ? value : ''}
      disabled={disabled || !isEditing}
      onChange={handleChange}
      placeholder={t('clampRatioPlaceholder')}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {isEditing ? (
              <Tooltip title={t('actions:done')}>
                <span>
                  <IconButton size="small" disabled={disabled} onClick={() => setEditing(false)}>
                    <Check fontSize="small" color="primary" />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title={t('setClampratioManually')}>
                <span>
                  <IconButton size="small" disabled={disabled} onClick={() => setEditing(true)}>
                    <Edit fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </InputAdornment>
        )
      }}
      {...props}
    />
  )
}
